import { render, staticRenderFns } from "./ViewSettingDetail.vue?vue&type=template&id=91be9232&scoped=true&"
import script from "./ViewSettingDetail.vue?vue&type=script&lang=js&"
export * from "./ViewSettingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingDetail.vue?vue&type=style&index=0&id=91be9232&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91be9232",
  null
  
)

export default component.exports